<lib-sales-insights-card
  [cardTitle]="config?.title"
  [subtitle]="subtitle"
  [loading]="false"
  [error]="error"
  [empty]="empty"
>
  <div class="si-tiles" [class.si-tiles--headed]="!!config?.title || !!subtitle">
    @if (loading) {
      @for (bone of skeletonTiles; track bone) {
        <div class="si-tiles__tile si-tiles__tile--loading" aria-hidden="true">
          <span class="si-tiles__top">
            <span class="si-tiles__icon si-tiles__bone"></span>
            <span class="si-tiles__bone si-tiles__bone--label"></span>
          </span>
          <span class="si-tiles__bone si-tiles__bone--value"></span>
        </div>
      }
    } @else {
      @for (tile of tiles; track tile.key) {
        <button
          type="button"
          [class]="'si-tiles__tile si-tiles__tile--' + tile.tone"
          [class.si-tiles__tile--clickable]="filterable && !!tile.flag"
          [class.si-tiles__tile--active]="filterable && !!tile.flag && activeFlag === tile.flag"
          [class.si-tiles__tile--reached]="tile.progress !== null && tile.progress >= 100"
          [style.--si-tile-rgb]="tile.rgb"
          [disabled]="!(filterable && tile.flag)"
          [attr.aria-pressed]="filterable && tile.flag ? activeFlag === tile.flag : null"
          (click)="select(tile)"
        >
          <span class="si-tiles__top">
            <span class="si-tiles__icon" aria-hidden="true"><i [class]="tile.icon"></i></span>
            <span class="si-tiles__label">{{ tile.label || (tile.labelKey | translate) }}</span>
          </span>
          <span class="si-tiles__body">
            <span class="si-tiles__figures">
              <span class="si-tiles__value">{{ tile.value }}</span>
              @if (tile.sub) {
                <span class="si-tiles__sub">
                  {{ tile.sub.key ? (tile.sub.key | translate: tile.sub.params) : tile.sub.text }}
                </span>
              }
            </span>
            @if (tile.progress !== null && tile.ring) {
              <span class="si-tiles__ring" aria-hidden="true">
                <svg viewBox="0 0 40 40">
                  <circle class="si-tiles__ring-track" cx="20" cy="20" [attr.r]="ringRadius"></circle>
                  <circle
                    class="si-tiles__ring-value"
                    cx="20"
                    cy="20"
                    [attr.r]="ringRadius"
                    [attr.stroke-dasharray]="ringCircumference"
                    [attr.stroke-dashoffset]="ringOffset(tile)"
                  ></circle>
                </svg>
                @if (tile.progressLabel) {
                  <span class="si-tiles__ring-label">{{ tile.progressLabel }}</span>
                } @else if (tile.progress >= 100) {
                  <i class="fa-solid fa-check si-tiles__ring-label"></i>
                }
              </span>
            }
          </span>
          @if (tile.progress !== null && !tile.ring) {
            <span class="si-tiles__bar" aria-hidden="true">
              <span [style.width.%]="tile.progress"></span>
            </span>
          }
        </button>
      }
    }
  </div>
</lib-sales-insights-card>
